import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const APP_ID = '2779bfd95a76a3f4b3d5c4612cb521e5ca9e8327';
const APP_SECRET =
  '7jXdrld67MjX9/2ksz0LoWV3DFBD0V8TTlKQ/TgUmKlikrH4OS4dZKXtplmBdTkRHA6NpLVPqJi/ZtbaRB9WkA==';
//SECRET IDS Mifiel
//const APP_ID = process.env.REACT_APP_MIFIEL_APP_ID;
//const APP_SECRET = process.env.REACT_APP_MIFIEL_APP_SECRET;
const is_sandbox = true;
export default function Mifiel() {
  const location = useLocation();
  const widgetId = location.state?.widgetId;
  const [fileBuffer, setFileBuffer] = useState(null);
  useEffect(() => {
    (window.mifiel = window.mifiel || []),
      (function () {
        'use strict';
        for (
          var e = ['widget'],
            i = function (e) {
              return function () {
                window.mifiel.push([e].concat(Array.prototype.slice.call(arguments, 0)));
              };
            },
            t = 0;
          t < e.length;
          t++
        ) {
          var n = e[t];
          window.mifiel[n] || (window.mifiel[n] = i(n));
        }
        if (!document.getElementById('mifiel-js')) {
          var r = document.createElement('script'),
            o = document.getElementsByTagName('script')[0];
          (r.type = 'text/javascript'),
            (r.id = 'mifiel-js'),
            (r.async = !0),
            (r.src = 'https://sandbox.mifiel.com/sign-widget-v1.0.0.js'),
            o.parentNode.insertBefore(r, o);
        }
      })();
    window.mifiel.widget({
      widgetId: widgetId,
      //widgetId: widgetId || 'uLqXoWdTU2',
      appendTo: 'mifiel-widget',
      successBtnText: 'Proceed to next step',
      onSuccess: {
        // here the code you want to execute after the signer successfully sign and click the button could be an url  'mifiel.com' or a function() {}
        callToAction: function () {
          //Navigate to onboargind/phone
          alert('documento firmado');
        }
      },
      onError: {
        // here the code you want to execute after an error occurs, could be an url  'mifiel.com' or a function() {}
        callToAction: 'https://www.mifiel.com'
      }
    });
  }, []);
  return (
    <>
      <p>...Contracts</p>
      <div id="mifiel-widget"></div>
    </>
  );
}
